<template>
  <div>
    <ui-hr>event settings</ui-hr>
    <ui-checkbox v-model="value.needLogin" toggle>需要登陆才能投稿</ui-checkbox>
    <ui-checkbox v-model="value.anonymous" toggle>anonymous</ui-checkbox>
    <ui-checkbox v-if="value.anonymous" v-model="value.memberrAnonymous" toggle>anonymous for all</ui-checkbox>
    <ui-checkbox v-model="showOpenDate" toggle>设置open date</ui-checkbox>
    <ui-checkbox v-model="showEndDate" toggle>设置结束时间</ui-checkbox>
    <transition name="fade">
      <div v-if="showOpenDate">
        <ui-hr>open time</ui-hr>
        <date-picker :not-before="now" v-model="value.openDate" placeholder="Select Open Date"></date-picker>
        <date-picker v-model="value.openDate" type="time" format="HH:mm:ss" placeholder="Select Open Time"></date-picker>
        <p>
          <ui-checkbox v-model="value.ignoreOpenDate" toggle>open date之前也可浏览他人内容</ui-checkbox>
        </p>
        <p>
          <ui-checkbox v-model="value.canAddAfterOpen" toggle>open date之后也可以投稿</ui-checkbox>
        </p>
      </div>
    </transition>
    <transition name="fade">
      <div v-if="showEndDate">
        <ui-hr>end time</ui-hr>
        <date-picker :not-before="now" v-model="value.endDate" placeholder="Select end Date"></date-picker>
        <date-picker v-model="value.endDate" type="time" format="HH:mm:ss" placeholder="Select end Time"></date-picker>
      </div>
    </transition>
  </div>
</template>
<script>
import dayjs from 'dayjs'
import DatePicker from 'vue2-datepicker'
export default {

  name: 'EventOptions',

  data() {
    return {
      showOpenDate: false,
      showEndDate: false,
      now: new Date(),
      defaultTime: dayjs().add(1, 'month').set('hour', 0).set('minute', 0).set('second', 0).format(),
    }
  },
  components: {
    DatePicker
  },
  props: ['value'],
  watch: {
    showEndDate(value) {
      if (value) {
        this.value.endDate = this.value.endDate || dayjs(this.defaultTime).add(1, 'month')
      } else {
        this.value.endDate = null
      }
    },
    showOpenDate(value) {
      if (value) {
        this.value.openDate = this.value.openDate || this.defaultTime
      } else {
        this.value.openDate = null
      }
    }
  },
  mounted() {
    if (this.value.endDate) {
      this.showEndDate = true
    }
    if (this.value.openDate) {
      this.showOpenDate = true
    }
  }
}

</script>
<style lang="css" scoped>
</style>
